import TYPES from './TYPES';

export const initialValue = {
  isOpen: false,
};

const reducer = (state = initialValue, action) => {
  switch (action.type) {
    case TYPES.SET_IS_OPEN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      throw new Error();
  }
};

export default reducer;
